import { useQuery } from "@tanstack/react-query";
import DocumentsRepository from "@/repositories/documents/documents-repository";

const documentsRepository = DocumentsRepository.getInstance();

/**
 * Hook for fetching the count of pending document requests
 *
 * Returns the number of active document requests that require user attention.
 * Useful for displaying notification badges or counts.
 *
 * @example
 * ```tsx
 * const { data, isError, isFetching } = useGetRequestsCount();
 * const count = data?.data?.count || 0;
 * ```
 *
 * @returns Query result containing the count of pending document requests
 */
export default function useGetRequestsCount() {
  const queryFn = () => documentsRepository.getRequestsCount();

  const { data, isError, isFetching } = useQuery({
    queryKey: ["requestsCount"],
    queryFn,
  });

  return { data, isError, isFetching };
}
